// Server-rendered fragments keep money formatting, imagery and sale state
// together. Selection is synchronous, so rapid clicks cannot race a fetch.
if (!customElements.get('managed-colour-card')) {
  customElements.define('managed-colour-card', class extends HTMLElement {
    connectedCallback() {
      if (!this.bound) {
        this.bound = true;
        this.addEventListener('click', (event) => this.selectPreview(event));
      }
      this.choices = this.querySelector('[data-colour-choices]');
      this.previews = [...this.querySelectorAll('[data-colour-preview]')];
      this.more = this.querySelector('[data-colour-more]');
      if (!this.choices || !this.more) return;
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.fitPreviews());
      this.resizeObserver.observe(this.choices);
      this.fitPreviews();
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.fitPreviews();
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    fitPreviews() {
      if (!this.choices || !this.more) return;
      const availableWidth = this.choices.getBoundingClientRect().width;
      if (!availableWidth) return;
      const focusedPreview = this.previews.find((preview) => preview === document.activeElement);
      this.previews.forEach((preview) => { preview.hidden = false; });
      this.more.hidden = false;
      const gap = parseFloat(getComputedStyle(this.choices).columnGap) || 0;
      const widths = this.previews.map((preview) => preview.getBoundingClientRect().width);
      const total = Math.max(Number(this.dataset.colourTotal) || 0, widths.length);
      let visible = widths.length;
      for (; visible >= 0; visible--) {
        const remaining = total - visible;
        this.more.textContent = `+${remaining}`;
        const moreWidth = remaining ? this.more.getBoundingClientRect().width : 0;
        const itemCount = visible + (remaining ? 1 : 0);
        const needed = widths.slice(0, visible).reduce((sum, width) => sum + width, 0)
          + moreWidth + Math.max(0, itemCount - 1) * gap;
        if (needed <= availableWidth || visible === 0) break;
      }
      const remaining = total - visible;
      this.previews.forEach((preview, index) => { preview.hidden = index >= visible; });
      this.more.hidden = remaining === 0;
      this.more.setAttribute('aria-label', remaining === 1
        ? this.dataset.moreLabelOne : this.dataset.moreLabel.replace('[count]', remaining));
      if (focusedPreview?.hidden) this.more.focus();
    }

    selectPreview(event) {
      const preview = event.target.closest('[data-colour-preview]');
      if (!preview || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const card = this.closest('.card-tile');
      const fragments = preview.querySelector('template[data-colour-fragments]')?.content;
      const media = card?.querySelector('.card-tile__media');
      const price = card?.querySelector('.card-tile__info .card-tile__price');
      if (!fragments || !media || !price) return;
      event.preventDefault();
      const image = fragments.querySelector('[data-colour-image]');
      media.replaceChildren(...image.cloneNode(true).childNodes);
      price.replaceWith(fragments.querySelector('.card-tile__price').cloneNode(true));
      card.querySelector('.card-tile__media-wrap > .card-tile__badge')?.remove();
      const badge = fragments.querySelector('.card-tile__badge');
      if (badge) media.parentElement.append(badge.cloneNode(true));
      card.querySelectorAll('a.card-tile__media, a.card-tile__info, a.card-tile__quick-add-link').forEach((link) => {
        link.href = preview.href;
      });
      card.querySelectorAll('modal-opener [data-product-url]').forEach((trigger) => {
        trigger.dataset.productUrl = preview.getAttribute('href');
      });
      this.querySelectorAll('[data-colour-preview]').forEach((link) => {
        link.setAttribute('aria-current', String(link === preview));
      });
      this.querySelector('[data-colour-card-name]').textContent = preview.dataset.colourName;
      if (this.more) this.more.href = preview.href;
      this.fitPreviews();
    }
  });
}
